<template>
  <div class="productcard-frontdeck">
    <component :is="href ? 'a' : 'div'" :href="href" @click="$emit('on-goto-page')">
      <h2
        class="m-b-0 product-heading"
        :class="
          miniCard ? 'font-responsive-small' : 'font-responsive-body   -ellipsis'
        "
      >
        <span
          v-if="!miniCard"
          class="d-block font-responsive-small -small-caps"
          v-html="insertString('Global', genderKey) || '&nbsp;'"
        />
        <span class="-bold" v-html="model.Concept" />
        <span v-if="!miniCard" v-html="'&nbsp;'" />
        <br v-else />
        <span :class="{ '-thin': !miniCard }" v-html="productName" />
      </h2>
    </component>

    <!-- <a
      :href="!miniCard ? href : null"
      @click="!miniCard ? $emit('on-goto-page') : () => {}"
    > -->
      <div
        class="price-colors flex-row flex-wrap font-responsive-small"
        :class="{ 'm-t-0': miniCard }"
      >
        <div v-if="outletAccess" class="d-flex m-r-6">
          <div>
            <span
              >{{ currentVariantPrice.currencyCode }}
              {{ currentVariantPrice.price }}</span
            >
            <span
              v-if="currentVariantPrice.hasDiscount"
              class="font-responsive-small -linethrough m-l-6"
              >{{ currentVariantPrice.fullPrice }}</span
            >
          </div>
          <InfoToolTip
            v-if="currentVariantPrice.hasDiscount && miniCard"
            :local="true"
            :reverse="index / 2 !== Math.floor(index / 2)"
            :type="'exclamation'"
            :text="insertString('Global', 'OutletFullPriceInfoText')"
            style="margin-top: -1px"
          />
        </div>
        <div v-if="variantCount > 1" class="font-responsive-small">
          {{ variantCount }}
          {{ insertString("Global", "Colors") }}
        </div>
        <div v-else-if="variantCount === 1" class="font-responsive-small">
          <span>{{ currentVariant.ColorName }}</span>
        </div>
      </div>
    <!-- </a> -->

    <div
      v-if="outletAccess && productReleased && miniCard"
      class="font-responsive-small -underline -clickable"
      @click.stop="$emit('on-quick-buy')"
    >
      {{
        !addingToBag
          ? insertString("Global", "QuickBuy")
          : insertString("Product", "Adding")
      }}
    </div>
    <div
      v-else-if="!productReleased && !isPrePurchase && miniCard"
      class="font-responsive-small -clickable -underline"
      @click="$emit('on-notify')"
    >
      {{ insertString("Product", "GetNotified") }}
    </div>
    <div
      v-else-if="isPrePurchase && miniCard"
      class="font-responsive-small -clickable -underline"
      @click="$emit('on-prepurchase')"
    >
      {{ insertString("Product", "PreOrderButton") }}
    </div>
  </div>
</template>
<script>
import { ProductIsAvailable } from '@/Scripts/lib/helper/dateHelper.js';
import { ProductPrices } from '@/Scripts/lib/helper/productHelper.js';
const InfoToolTip = () => import('@/Scripts/components/shared/InfoToolTip/InfoToolTip.vue');

export default {
  components: {
    InfoToolTip
  },
  props: {
    index: Number,
    model: Object,
    currentVariant: Object,
    productName: String,

    variantCount: Number,
    outletAccess: Boolean,
    miniCard: Boolean,
    isPrePurchase: Boolean,
    href: String
  },
  data () {
    return {
      addingToBag: false
    };
  },
  computed: {
    genderKey () {
      return {
        Male: 'Mens',
        Female: 'Womens',
        Unisex: 'Unisex',
        Junior: 'Junior'
      }[this.model.Gender];
    },

    currentVariantPrice () {
      return ProductPrices(this.currentVariant);
    },
    productReleased () {
      if (!this.model.AvailableFrom) {
        return true;
      }
      return this.outlet || ProductIsAvailable(this.model.AvailableFrom);
    }
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";
.productcard-frontdeck {
  @include media-breakpoint-up(md) {
    position: absolute;
    top: 0;
    width: 100%;
  }
}
.productcard-frontdeck.productcard-frontdeck {
  color: inherit;
  a {
    color: inherit;
  }
}
</style>
